<template>
    <h1>Byu4you</h1>
</template>

<script>
    export default {
        name: "Byu4you"
    }
</script>
